import { formatString } from './stringUtils';

export function rangeCap(value, min, max) {
	const number = Number.parseFloat(value);

	if (Number.isNaN(number)) {
		return min;
	}

	return (number < min)
		? min
		: (number > max)
			? max
			: number;
}

export function inRange(value, min, max, inclusive = false) {
	const number = Number.parseFloat(value);

	if (Number.isNaN(number)) {
		return false;
	}

	return inclusive
		? (number >= min && number <= max)
		: (number >= min && number < max);
}

export function toTimer(value) {
	const nrSeconds = Number(value) || 0;
	const secs = Math.floor(nrSeconds % 60);
	const mins = Math.floor((nrSeconds / 60) % 60);
	const hours = Math.floor(nrSeconds / (60 * 60));

	const strSecs = String(secs).padStart(2, '0');
	const strMins = String(mins).padStart(2, '0');
	const strHours = String(hours).padStart(2, '0');

	return formatString('{0}:{1}:{2}', strHours, strMins, strSecs);
}

export function secondsToDHM(value) {
	const secsPerDay = 86400;
	const secsPerHour = 3600;
	const secsPerMinute = 60;

	let seconds = Math.abs(Number(value) || 0);
	const minus = ((Number(value) || 0) < 0) ? '-' : '';

	const days = Math.floor(seconds / secsPerDay);
	seconds %= secsPerDay;
	const hours = Math.floor(seconds / secsPerHour);
	seconds %= secsPerHour;
	const minutes = Math.floor(seconds / secsPerMinute);

	const strDays = String(days).padStart(1, '0');
	const strHours = String(hours).padStart(2, '0');
	const strMinutes = String(minutes).padStart(2, '0');

	return `${minus}${strDays}D ${strHours}:${strMinutes}`;
}

export function countDecimals(value) {
	const numericValue = Number(value);

	if (!Number.isFinite(numericValue)) {
		return 0;
	}

	const strings = numericValue.toString().split('.');
	return (strings.length >= 2) ? strings[1].length : 0;
}

export function toNrDecimals(value, minDecs = 0, maxDecs = 2) {
	maxDecs = (maxDecs < minDecs) ? minDecs : maxDecs;

	let numericValue = Number(value ?? 0);
	if (!Number.isFinite(numericValue)) {
		numericValue = 0;
	}

	numericValue = Number(numericValue.toFixed(maxDecs));

	let strNum = numericValue.toString();
	let decimalIndex = strNum.indexOf('.');
	let noPeriod = (decimalIndex === -1);
	let nrDecs = noPeriod ? 0 : (strNum.length - decimalIndex - 1);
	let nrZeroPads = (minDecs - nrDecs);
	let needsPadding = (nrZeroPads > 0);
	let strZeroPads = needsPadding ? '0'.repeat(nrZeroPads) : '';

	return (noPeriod && needsPadding)
		? `${strNum}.${strZeroPads}`
		: `${strNum}${strZeroPads}`;
}

export function toFixedNumber(value, digits) {
	return Number(Number(value ?? 0).toFixed(digits));
}
